module.exports = __webpack_public_path__ + "static/img/2.15423d53.png";